import type { IconButtonProps } from '@mui/material/IconButton';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';


// ----------------------------------------------------------------------

export function MenuButton({ sx, ...other }: IconButtonProps) {
  return (
    <IconButton sx={sx} {...other}>
      <Box component='img' src='/assets/icons/icon_svg/menu.svg' width={16} height={16} />
      {/* <Iconify icon="custom:menu-duotone" width={24} /> */}
    </IconButton>
  );
}
